<app-cf-loader [size]="LoaderSize.Small" [style]="LoaderStyle.Circles">Redirecting...</app-cf-loader>